import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Clock, XCircle, ArrowRight } from "lucide-react";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const maxAttempts = 8;
    const poll = async () => {
      try {
        const r = await api.get(`/checkout/status/${sessionId}`);
        setData(r.data);
        if (r.data.payment_status === "paid") { setStatus("paid"); return; }
        if (r.data.status === "expired") { setStatus("error"); return; }
        attempts++;
        if (attempts < maxAttempts) setTimeout(poll, 2000);
        else setStatus("timeout");
      } catch {
        attempts++;
        if (attempts < maxAttempts) setTimeout(poll, 2000);
        else setStatus("error");
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="max-w-2xl mx-auto px-4 lg:px-8 py-16 lg:py-24 text-center fade-in has-bottom-nav" data-testid="checkout-success-page">
      {status === "checking" && (
        <>
          <div className="w-16 h-16 bg-black flex items-center justify-center mx-auto mb-6"><Clock size={28} strokeWidth={2.5} className="text-white"/></div>
          <h1 className="text-4xl font-black tracking-tighter mb-3">Vérif du paiement…</h1>
          <p className="text-[color:var(--color-text-muted)]">On confirme avec Stripe.</p>
        </>
      )}
      {status === "paid" && (
        <>
          <div className="w-20 h-20 bg-[color:var(--color-mint)] border-2 border-black flex items-center justify-center mx-auto mb-6"><CheckCircle2 size={36} strokeWidth={2.5}/></div>
          <p className="label mb-3">Paiement confirmé</p>
          <h1 className="text-4xl lg:text-6xl font-black tracking-tighter mb-4">Merci ✨</h1>
          <p className="text-lg text-[color:var(--color-text-muted)] mb-2">Paiement de <strong className="text-black">{(data?.amount_total/100)?.toFixed(2)}€</strong> reçu.</p>
          <p className="text-sm text-[color:var(--color-text-muted)] mb-10">Le vendeur prépare ton colis.</p>
          <div className="flex gap-3 justify-center flex-wrap">
            <Link to="/dashboard" className="btn btn-primary" data-testid="goto-dashboard-btn">Voir mes commandes <ArrowRight size={14} strokeWidth={3}/></Link>
            <Link to="/catalogue" className="btn btn-ghost">Continuer mes trouvailles</Link>
          </div>
        </>
      )}
      {(status === "error" || status === "timeout") && (
        <>
          <div className="w-20 h-20 bg-[color:var(--color-coral)] border-2 border-black flex items-center justify-center mx-auto mb-6"><XCircle size={36} strokeWidth={2.5} className="text-white"/></div>
          <h1 className="text-4xl font-black tracking-tighter mb-3">Paiement en attente</h1>
          <p className="text-[color:var(--color-text-muted)]">Si tu as été débité, on créera la commande sous peu.</p>
          <Link to="/panier" className="btn btn-ghost mt-8 inline-block">Retour au panier</Link>
        </>
      )}
    </div>
  );
}
